import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap, UtensilsCrossed, Home, Heart, Sunrise } from "lucide-react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";

const iconMap = { GraduationCap, UtensilsCrossed, Home, Heart, Sunrise };

export default function Programs() {
  const { t } = useI18n();
  const [programs, setPrograms] = useState([]);
  useEffect(() => { api.get("/programs").then(r => setPrograms(r.data)).catch(() => {}); }, []);
  return (
    <div className="bg-ivory" data-testid="programs-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.programs.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-[1.05] mt-3">{t("pages.programs.t1")}<br/><span className="italic text-warm-orange">{t("pages.programs.t2")}</span></h1>
        </div>
      </section>
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-5 lg:px-10 space-y-16">
          {programs.map((p, i) => {
            const Icon = iconMap[p.icon] || Heart;
            const alt = i % 2 === 1;
            return (
              <div key={p.id} className={`grid lg:grid-cols-12 gap-10 items-center ${alt ? "lg:flex-row-reverse" : ""}`} data-testid={`program-${p.id}`}>
                <div className={`lg:col-span-5 ${alt ? "lg:col-start-8" : ""}`}>
                  <div className="aspect-[4/3] rounded-2xl bg-deep-blue relative overflow-hidden">
                    <div className="absolute inset-0 grid place-items-center">
                      <Icon size={110} className="text-gold" />
                    </div>
                    <div className="absolute bottom-4 left-4 text-gold font-display text-6xl opacity-30">0{i+1}</div>
                  </div>
                </div>
                <div className={`lg:col-span-6 ${alt ? "lg:col-start-1 lg:row-start-1" : ""}`}>
                  <div className="text-xs uppercase tracking-[0.25em] text-warm-orange">{t("programs.label")} {i+1}</div>
                  <h2 className="font-display text-4xl sm:text-5xl text-deep-blue mt-3 leading-tight">« {p.title} »</h2>
                  <p className="text-deep-blue/70 mt-5 leading-relaxed">{p.description}</p>
                  <ul className="mt-5 grid grid-cols-2 gap-2">
                    {(p.actions || []).map((a, k) => (
                      <li key={a} className="flex items-start gap-2 text-sm text-deep-blue/80">
                        <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2"></span>{a}
                      </li>
                    ))}
                  </ul>
                  <Link to="/faire-un-don" className="btn-gold mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold" data-testid={`prog-cta-${p.id}`}>
                    {p.cta || t("programs.supportThis")} <ArrowRight size={14}/>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
